import React, { useState } from 'react'

import { FaqAccordion } from '@/shared/components/Accordion/FaqAccordion'
import { pxToRem } from '@/shared/styles/themes'
import { Box, Divider, styled, Typography } from '@mui/material'

import type { FaqItem } from './types'

interface ProductFaqSectionProps {
  faq: FaqItem[]
}

export const ProductFaqSection: React.FC<ProductFaqSectionProps> = ({ faq }) => {
  const [expanded, setExpanded] = useState<number | false>(false)

  const handleChange = (index: number) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? index : false)
  }

  return (
    <StyledSection>
      <Divider sx={{ mb: 4 }} />
      <Typography variant="h5" component="h2" gutterBottom>
        Frequently Asked Questions
      </Typography>
      <Box>
        {faq.map((item, index) => (
          <FaqAccordion
            key={item.question}
            question={item.question}
            answer={item.answer}
            expanded={expanded === index}
            onChange={handleChange(index)}
          />
        ))}
      </Box>
    </StyledSection>
  )
}

const StyledSection = styled(Box)`
  padding: ${pxToRem(16)} 0 ${pxToRem(48)};
`
